import API, { defaultConfig } from './config';

export const OnboardingVideosAPI = {
    async listActiveOnboardingVideos() {
        try {
            const response = await API.get('/onboardingVideos/listActive', defaultConfig);
            return {
                success: true,
                body: response.data,
            };
        } catch (error) {
            return {
                success: false,
                body: error.response?.data,
            };
        }
    },
};
